import { useEffect, useState } from 'react';
import { useFormik } from 'formik';

import { initialValues, validationSchema } from './formData';
import { ProductDataProps } from './props';

import { Product } from '../../../../../../shared/types/systemConfiguration/products';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';
import { asyncGetParams } from '../../../../../../services/param.service';

export const useProductData = ({
    data,
    onChangeData,
    onChangeFormik,
}: ProductDataProps) => {
    const [sfcCaptureUnitNews, setSfcCaptureUnitNews] = useState<ISelect[]>([]);

    const onSubmit = (data: Product) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema: validationSchema(),
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('code', data?.code);
        formik?.setFieldValue('name', data?.name || '');
        formik?.setFieldValue('description', data?.description || '');
        formik?.setFieldValue('active', data?.active ?? true);
        formik?.setFieldValue(
            'applyEscalations',
            data?.applyEscalations ?? true
        );
        formik?.setFieldValue('applyPqr', data?.applyPqr ?? true);
        formik?.setFieldValue(
            'sfcCaptureUnitNew',
            (data?.sfcCaptureUnitNew as ISelect)?.id || ''
        );
    }, [data]);

    useEffect(() => {
        asyncGetParams(ParamEnum.SFC_CAPTURE_UNIT_NEW).then((items) =>
            setSfcCaptureUnitNews(items)
        );
    }, []);

    return {
        formik,
        sfcCaptureUnitNews,
    };
};
